import React, { FC, useEffect, useState } from 'react';
import styles from './step1.module.scss';
import classNames from 'classnames/bind';
import { CommonCard } from '../../common/card';
import { CommonButton } from '../../common/button';
import useInterviewPracticeStore from '@stores/InterviewStore/InterviewPracticeStore';
import { shallow } from 'zustand/shallow';
import Text from '@components/common/text';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import Button from '@components/common/button';

const cx = classNames.bind(styles);

interface Step1Props {
  entered: boolean;
}

export const Step1: FC<Step1Props> = ({ entered }) => {
  const toNextStep = useInterviewPracticeStore((state) => state.practiceStepInfo.toNextStep, shallow);
  const [enabled, setEnabled] = useState(entered);

  const handleClickNext = () => {
    toNextStep();
  };

  useEffect(() => {
    setTimeout(() => setEnabled(true), 100);
  }, []);

  return (
    <CommonCard className={cx('card', { enabled })}>
      <Text fontStyle={FontStyle.H4_B} styles={{ textAlign: 'center', marginBottom: 24 }}>
        면접 연습은 준비시간과 <br />
        답변시간으로 구성되어 있습니다.
      </Text>
      <div className={cx('image')} />
      <div className={cx('footer')}>
        <Button onClick={handleClickNext} styles={{ width: 168, height: 48 }}>
          확인 완료
        </Button>
      </div>
    </CommonCard>
  );
};
